import { StyleSheet, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, control, fontFamily, space, spacing, type } from '~/ui/tokens';

interface ProgressStepsProps {
  steps: string[];
  currentStep: number; // 1-indexed
}

export function ProgressSteps({ steps, currentStep }: ProgressStepsProps) {
  return (
    <View style={styles.row}>
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const completed = stepNumber < currentStep;
        const current = stepNumber === currentStep;

        return (
          <View key={label} style={styles.step}>
            <View style={styles.stepColumn}>
              <View style={[styles.circle, (completed || current) && styles.circleActive]}>
                {completed ? (
                  <Ionicons name="checkmark" size={16} color={colors.white} />
                ) : (
                  <Text style={[styles.circleLabel, current && styles.circleLabelActive]}>
                    {stepNumber}
                  </Text>
                )}
              </View>
              <Text style={[styles.stepLabel, current && styles.stepLabelActive]}>{label}</Text>
            </View>
            {stepNumber < steps.length ? (
              <View style={[styles.connector, completed && styles.connectorActive]} />
            ) : null}
          </View>
        );
      })}
    </View>
  );
}

const CIRCLE_SIZE = 32;

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  step: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  stepColumn: {
    alignItems: 'center',
    gap: space.related,
  },
  circle: {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    borderRadius: CIRCLE_SIZE / 2,
    borderWidth: 2,
    borderColor: colors.line,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.card,
  },
  circleActive: {
    borderColor: colors.brand,
    backgroundColor: colors.brand,
  },
  circleLabel: {
    fontFamily: fontFamily.semibold,
    ...control.secondaryCta,
    color: colors.inkFaint,
  },
  circleLabelActive: {
    color: colors.white,
  },
  stepLabel: {
    fontFamily: fontFamily.medium,
    ...type.metadata,
    color: colors.inkFaint,
  },
  stepLabelActive: {
    color: colors.ink,
  },
  connector: {
    flex: 1,
    height: 2,
    backgroundColor: colors.line,
    marginHorizontal: spacing(1),
    marginBottom: 20, // aligns with circle center, above the label
  },
  connectorActive: {
    backgroundColor: colors.brand,
  },
});
